import { createApp } from "vue";
import { createPinia } from "pinia";
import { createI18n } from "vue-i18n";

import App from "./App.vue";
import router from "./router";

const pinia = createPinia();

import en from "./locales/en.json";
import fr from "./locales/fr.json";

const i18n = createI18n({
  locale: "en", // set locale
  fallbackLocale: "en", // set fallback locale
  // globalInjection: true,
  messages: {
    en,
    fr,
  },
});

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(i18n);
app.mount("#app");
